import { DecoratorNode } from "lexical";

// Inline image node for the editor. The toolbar's Insert Image button uploads
// the file via `uploadTemplateImage` and inserts the returned URL as `src`.
export class ImageNode extends DecoratorNode {
  __src;
  __alt;

  static getType() {
    return "contract-image";
  }

  static clone(node) {
    return new ImageNode(node.__src, node.__alt, node.__key);
  }

  constructor(src, alt = "", key) {
    super(key);
    this.__src = src;
    this.__alt = alt;
  }

  createDOM() {
    const img = document.createElement("img");
    img.src = this.__src;
    img.alt = this.__alt;
    img.className = "contract-inline-image";
    img.setAttribute("contenteditable", "false");
    return img;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return null;
  }

  exportDOM() {
    const img = document.createElement("img");
    img.setAttribute("src", this.__src);
    img.setAttribute("alt", this.__alt || "");
    // Sizing must ride along on the element: the exported HTML is also rendered
    // outside this app (PDF/email), where our stylesheet isn't loaded, and
    // classes don't survive the edit round-trip.
    img.setAttribute("style", "max-width:100%;height:auto;");
    return { element: img };
  }

  static importDOM() {
    return {
      img: () => ({
        conversion: (domNode) => ({
          node: new ImageNode(
            domNode.getAttribute("src") || "",
            domNode.getAttribute("alt") || ""
          ),
        }),
        priority: 1,
      }),
    };
  }

  isInline() {
    return true;
  }

  exportJSON() {
    return {
      type: "contract-image",
      src: this.__src,
      alt: this.__alt,
      version: 1,
    };
  }

  static importJSON(json) {
    return new ImageNode(json.src, json.alt);
  }
}

export const $createImageNode = (src, alt) => new ImageNode(src, alt);
export const $isImageNode = (node) => node instanceof ImageNode;
